<template>
  <pt-integral-goods-detail :id="id" class="pt-integral-goods-detail__page"></pt-integral-goods-detail>
</template>

<script>
import PtIntegralGoodsDetail from 'cps/integral-mall-manage/pt-goods-of-integral/pt-integral-goods-detail/withData'
export default {
  name: 'pt-integral-goods-detail__view',
  components: {
    'pt-integral-goods-detail': PtIntegralGoodsDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
